module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dl', {
    staticClass: "my-device-define"
  }, [_c('dt', [_vm._v("PCをお使いの方")]), _vm._v(" "), _c('dd', [_c('ul', {
    staticClass: "my-link-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.google.co.jp/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Chrome（最新版）")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.mozilla.org/ja/firefox/",
      "target": "_blank"
    }
  }, [_vm._v("Firefox（最新版）")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://support.microsoft.com/ja-jp/help/17621/internet-explorer-downloads",
      "target": "_blank"
    }
  }, [_vm._v("Internet Explorer（11以降）※Windowsのみ")])])])]), _vm._v(" "), _c('dt', [_vm._v("スマートフォンをお使いの方")]), _vm._v(" "), _c('dd', [_c('ul', {
    staticClass: "my-link-list"
  }, [_c('li', [_c('dfn', [_vm._v("iPhone")]), _vm._v(" "), _c('p', {
    staticClass: "my-guide"
  }, [_vm._v("iOS10以上へアップデートした状態のSafariでご利用ください。")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://support.apple.com/ja-jp/HT204204",
      "target": "_blank"
    }
  }, [_vm._v("※アップデート方法")])]), _vm._v(" "), _c('li', [_c('dfn', [_vm._v("Android")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.android.chrome&hl=ja",
      "target": "_blank"
    }
  }, [_vm._v("Chrome（最新版）")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145e57e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/manager/DbManager/dialogs/partials/CompatibleTable.vue
// module id = 456
// module chunks = 1